import HireTalent from './pages/HireTalent';
import HireTalent2 from './pages/HireTalent2';
import TalentProfile from './pages/TalentProfile';
import Login from './pages/Login';
import { Provider } from 'react-redux';
import { BrowserRouter, BrowserRouter as Router, Link, Route, Routes } from 'react-router-dom';
import HireTalent3 from './pages/HireTalent3';
import HireTalent4 from './pages/HireTalent4';
import { store } from './store/Store';
import HireTalent5 from './pages/HireTalent5';
import HireTalent6 from './pages/HireTalent6';
function App() {
  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HireTalent />} />
            <Route path="/HireTalent2" element={<HireTalent2 />} />
            <Route path="/HireTalent3" element={<HireTalent3 />} />
            <Route path="/HireTalent4" element={<HireTalent4 />} />
            <Route path="/HireTalent5" element={<HireTalent5 />} />
            <Route path="/HireTalent6" element={<HireTalent6 />} />
            <Route path="/TalentProfile" element={<TalentProfile />} />
            <Route path="/Login" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;

